module.exports = __webpack_public_path__ + "img/knowledge-day.0184aa80.webp";